import { combineReducers } from "redux";
import recipesReducer from './recipes';
import pickedRecipeReducer from './pickedRecipe';
import searchTermsReducer from './searchTerms';

const rootReducer = combineReducers({
    recipes: recipesReducer,
    pickedRecipe: pickedRecipeReducer,
    searchTerms: searchTermsReducer
});

export default rootReducer;